module.exports = __webpack_public_path__ + "static/img/network02.a2bee493.png";